const MAPPINGS = {
  getChatQuestions: require('./chat-questions').default,
  getMineSurveyList: require('./mine-survey-list').default,
  saveChatQuestions: require('./submit-questions').default
}

/**
 * @param key
 */
export function peek (key) {
  const payload = MAPPINGS[key]

  return {
    ...payload,
    code: 200,
    message: ''
  }
}

/**
 * @param options
 */
export function mockAxiosAdapter (options) {
  return function mockAdapter (config) {
    // At this point:
    //  - config has been merged with defaults
    //  - request transformers have already run
    //  - request interceptors have already run

    // Make the request using config provided
    // Upon response settle the Promise

    return new Promise(function (resolve, reject) {
      const response = {
        data: peek(config.url.replace(options.baseURL || '', '')),
        status: 200,
        statusText: 'MOCK-DONE',
        headers: {},
        config: config,
        request: null
      }

      resolve(response)
      // settle(resolve, reject, response);

      // From here:
      //  - response transformers will run
      //  - response interceptors will run
    })
  }
}
